import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Attending } from '../../../model/attending';
import { AttendingService } from '../../../service/attending.service';
import { ToastService } from '../../../../shared/service/toast.service';
import { MonitoringStepStatus } from '../../../constants/monitoring-step-status';
import { VehicleService } from '../../../../diagnosis/service/vehicle.service';
import { DiagnosisWebSocketService } from '../../../../diagnosis/service/diagnosis-web-socket.service';
import { DiagnosisType } from '../../../../shared/model/diagnosis-type';
import { JiraIssueInfoService } from '../../../../shared/service/jira-info-service'
import { JiraIssueInfo } from '../../../model/jira-issue-info';

@Component({
  selector: 'tx-monitoring-conclusion',
  templateUrl: './monitoring-conclusion.component.html',
  styleUrls: ['./monitoring-conclusion.component.css']
})

export class MonitoringConclusionComponent implements OnInit {

  _attending: Attending;
  _viewMode: boolean;
  _authenticatedUser: any;
  _loading: boolean;
  jiraIssueInfo: JiraIssueInfo;

  justification: string;
  vehicle: any;
  doDiagnosis: boolean;
  testResults: Array<any>;
  issueTypes: Array<any>;
  storageOn: Array<any>;
  observationNeeded: string;
  failureCategories: Array<any>;
  failureCauses: Array<any>;

  constructor(private _attendingService: AttendingService,
    private _toastService: ToastService,
    private _vehicleService: VehicleService,
    private _diagnosisNotification: DiagnosisWebSocketService,
    private _JiraIssueInfoService: JiraIssueInfoService) {
    this.getTestResults();
    this.getIssueTypes();
    this.getStorageOn();
    this.getFailureCategories();
  }

  ngOnInit() {
    this._loading = false;
    this.doDiagnosis = false;
    this.setupObservers();
  }

  @Input()
  set attending(attending) {
    this._attending = attending;
    this.setupEmptyEntities();
    this.findVehicleForDiagnosis();
  }

  get attending() {
    return this._attending;
  }

  @Input()
  set viewMode(viewMode) {
    this._viewMode = viewMode;
  }

  get viewMode() {
    return this._viewMode;
  }

  @Input()
  set authenticatedUser(authenticatedUser) {
    this._authenticatedUser = authenticatedUser;
  }

  get authenticatedUser() {
    return this._authenticatedUser;
  }

  setBlockFeatureStatus(blockFeatureStatus) {
    this.jiraIssueInfo.blockFeatureStatus = blockFeatureStatus;
  }

  setRpmStatus(rpmStatus) {
    this.jiraIssueInfo.rpmStatus = rpmStatus;
  }

  setViolationSensorStatus(violationSensorStatus) {
    this.jiraIssueInfo.violationSensorStatus = violationSensorStatus;
  }

  setRfidReaderStatusTX12(rfidReaderStatusTX12) {
    this.jiraIssueInfo.rfidReaderStatusTX12 = rfidReaderStatusTX12;
  }

  setCanNetworkStatus(canNetworkStatus) {
    this.jiraIssueInfo.canNetworkStatus = canNetworkStatus;
  }

  setAccessoriesStatus(accessoriesStatus) {
    this.jiraIssueInfo.accessoriesStatus = accessoriesStatus;
  }

  setPanicFeatureStatus(panicFeatureStatus) {
    this.jiraIssueInfo.panicFeatureStatus = panicFeatureStatus;
  }

  setRainSensorStatus(rainSensorStatus) {
    this.jiraIssueInfo.rainSensorStatus = rainSensorStatus;
  }

  setHodometerStatus(hodometerStatus) {
    this.jiraIssueInfo.hodometerStatus = hodometerStatus;
  }

  setProvidedService(providedService) {
    this.jiraIssueInfo.providedService = providedService;
    this.setFailureCategory(null);
  }

  setEquipmentKeeper(equipmentKeeper) {
    this.jiraIssueInfo.equipmentKeeper = equipmentKeeper;
  }

  setFailureCategory(failureCategory) {
    this.getFailureCauses(failureCategory);
    this.jiraIssueInfo.failureCategory = failureCategory;
    this.setFailureCause(null);
  }

  setFailureCause(failureCause) {
    this.jiraIssueInfo.failureCause = failureCause;
  }

  loading() {
    return this._loading;
  }

  finish() {
    let finishMonitoring = {
      'attendingId': this._attending.id, 'monitoringId': this._attending.monitoring.id,
      'justification': this.justification, 'jiraIssueInfo': this.jiraIssueInfo
    };

    this._loading = true;
    this._attendingService.finishMonitoring(finishMonitoring)
      .add(() => {
        this._loading = false;
      });
  }

  update() {
    this._attendingService.setTechnicianScore(this._attending.id, this._attending.technicianScore).subscribe(
      response => {
        this.showMessage('Nota enviada com sucesso!');
      },
      error => {
        this.showMessage(error.text);
      }
    );
  }

  canFinish() {
    return (
      ((this.getPreviousDiagnosis() !== undefined && !this.getPreviousDiagnosis().approved) ? this.justification != null && this.justification !== '' : true) &&
      this._attending.diagnosisGeneralResults && this._attending.diagnosisGeneralResults.length > 0 || this.doDiagnosis) &&
      this.jiraIssueInfo.observationNeeded != null &&
      this.jiraIssueInfo.equipmentKeeper != null &&
      this.jiraIssueInfo.providedService != null &&
      (this.jiraIssueInfo.providedService === 'Instalação' || this.jiraIssueInfo.failureCause != null);
      
  }

  back() {
    this._attending.monitoring.conclusionStep = MonitoringStepStatus.NOT_STARTED;
    this._attending.monitoring.validationStep = MonitoringStepStatus.CURRENT;
  }

  canBack() {
    return true;
  }

  showEmptyState() {
    return !this._attending.diagnosisGeneralResults || this._attending.diagnosisGeneralResults.length === 0 && !this.doDiagnosis;
  }

  showRequiredJustification() {
    return this.getPreviousDiagnosis() !== undefined && !this.getPreviousDiagnosis().approved;
  }

  startDiagnosis() {
    this.doDiagnosis = true;
  }

  canStartDiagnosis() {
    return this.vehicle != null;
  }

  hasDiagnosis() {
    return this._attending.diagnosisGeneralResults && this._attending.diagnosisGeneralResults.length > 0;
  }

  getPreviousDiagnosis() {
    if (this.hasDiagnosis()) {
      return this._attending.diagnosisGeneralResults[0];
    }
    return undefined;
  }

  findVehicleForDiagnosis() {
    if (!this._diagnosisNotification.getCustomer()) {
      this._diagnosisNotification.setCustomer(this.attending.branch.customer);
    }
    if (!this.vehicle) {
      this._vehicleService.getVehiclesByUser(this.attending.branch.customer.trixUser.id, DiagnosisType.GENERAL);
    }
  }

  getTestResults() {
    this._JiraIssueInfoService
      .getTestResults()
      .subscribe(
        testResults => this.testResults = testResults,
        error => this.showMessage(error.text)
      );
  }

  getIssueTypes() {
    this._JiraIssueInfoService
      .getIssueTypes()
      .subscribe(
        issueTypes => this.issueTypes = issueTypes,
        error => this.showMessage(error.text)
      );
  }

  getStorageOn() {
    this._JiraIssueInfoService
      .getStorageStatus()
      .subscribe(
        storageOn => this.storageOn = storageOn,
        error => this.showMessage(error.text)
      );
  }
  getValueOfObservationNeeded() {
    if (this.jiraIssueInfo.observationNeeded) {
      return "Sim"
    }
    return "Não"
  }

  getFailureCategories() {
    this._JiraIssueInfoService
      .getFailureCategory()
      .subscribe(
        failureCategories => this.failureCategories = failureCategories,
        error => this.showMessage(error.text)
      );
  }

  getFailureCauses(failureCategory) {
    this._JiraIssueInfoService
      .getFailureCauseByCategory(failureCategory)
      .subscribe(
        failureCauses => this.failureCauses = failureCauses,
        error => this.showMessage(error.text)
      );
  }

  hasCause() {
    return this.jiraIssueInfo.failureCategory != null && this.jiraIssueInfo.failureCategory != "N/A"
  }
  
  needFailureCategory() {
    return this.jiraIssueInfo.providedService === "Reinstalação" || this.jiraIssueInfo.providedService === "Manutenção" ||
    this.jiraIssueInfo.providedService === "Auditoria";
  }

  private setupObservers() {
    this._vehicleService.find$
      .subscribe(vehicles => {
        this.vehicle = vehicles.find(vehicle => vehicle.plate === this._attending.vehiclePlate);
        if (this.vehicle !== undefined) {
          this.vehicle.attendingId = this._attending.id;
          this.vehicle.diagnosisType = DiagnosisType.GENERAL;
          this.vehicle.coordinateStartDate = this._attending.attendingInfo.startedDate;
        }
      });
  }

  private showMessage(message) {
    this._toastService.showMessage(message, 4000);
  }

  private setupEmptyEntities() {
    if (this._attending.monitoring.approvalJustification && this._attending.monitoring.approvalJustification !== "") {
      this.justification = this._attending.monitoring.approvalJustification;
    }
    if (this._attending.monitoring.jiraIssueInfo) {
      this.jiraIssueInfo = this._attending.monitoring.jiraIssueInfo;
    }
    if (this.jiraIssueInfo.observationNeeded) {
      this.observationNeeded = this.getValueOfObservationNeeded();
    }
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/monitoring/monitoring-conclusion/monitoring-conclusion.component.ts